<template>
  <v-row>
    <v-col>
      <FullWidthButton @click="showFAQ = true">Criteria FAQ</FullWidthButton>
    </v-col>
  </v-row>
  <v-row>
    <v-col v-for="item in criteriaGroupData?.data" :key="item.group_name" cols="12" md="2">
      <v-card class="mx-auto text-white" max-width="400" @click="openCriteriaDetail(item)">
        <v-img
          :src="item.thubmnail?.url"
          gradient="to top, rgba(0,0,0,.1), rgba(0,0,0,.5)"
          height="200px"
          cover>
          <template #sources>
            <source :srcset="item.thubmnail?.webp_url" />
          </template>
          <!-- Use absolute positioning to pin title to top -->
          <div
            class="d-flex flex-column pa-2"
            style="position: absolute; top: 0; left: 0; width: 100%">
            <v-card-title class="text-h5 py-1">{{ item.group_name }}</v-card-title>
          </div>

          <!-- Centered text at bottom -->
          <v-card-text class="py-0 text-center" style="position: absolute; bottom: 0; width: 100%">
            <div
              style="
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 5rem; /* adjust as needed */
                font-weight: bold;
                color: white;
                pointer-events: none; /* so clicks pass through if needed */
              ">
              {{ getRemaining(item.id) }}
            </div>
          </v-card-text>
        </v-img>
      </v-card>
    </v-col>
  </v-row>
  <v-dialog v-model="openSubView">
    <CriteriaGroupSubview
      :criteria-group="selectedCriteriaGroup"
      :branchYearId="branchYearId"
      @close="openSubView = false"></CriteriaGroupSubview>
  </v-dialog>
  <v-dialog v-model="showFAQ" scrollable max-width="800px">
    <v-card>
      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div v-html="yearData?.criteria_faq"></div>
      </v-card-text>
      <v-card-actions>
        <FullWidthButton @click="showFAQ = false">Close</FullWidthButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { CriteriaGroupDTO, ICriteriaGroupDTO } from '@/dtos';
import { useCriteriaStore, useYearStore } from '@/stores';
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import CriteriaGroupSubview from './subviews/CriteriaGroupSubview.vue';
import { SNACKSTATUS } from '@/stores/util';

const route = useRoute();
const criteriaStore = useCriteriaStore();
const openSubView = ref<boolean>(false);
const selectedCriteriaGroup = ref<ICriteriaGroupDTO>(new CriteriaGroupDTO());
const yearId = ref<string>(
  Array.isArray(route.query.yearId) ? (route.query.yearId[0] ?? '') : (route.query.yearId ?? ''),
);
const emit = defineEmits<{
  (e: 'snack', objType: string, snackType: SNACKSTATUS, err?: string): void;
}>();

const yearStore = useYearStore();
const showFAQ = ref<boolean>(false);
const branchYearId = ref<string>(
  Array.isArray(route.query.branchYearId)
    ? (route.query.branchYearId[0] ?? '')
    : (route.query.branchYearId ?? ''),
);

const { data: yearData } = yearStore.getYearAnonQuery(yearId);
const { data: criteriaRemaining, isLoading } = criteriaStore.getRemainingCriteriaData(branchYearId);

const { data: criteriaGroupData, isLoading: isCriteriaGroupLoading } =
  criteriaStore.getCriteriaGroupsForYearQuery(yearId);

const getRemaining = (groupId: string) => {
  return criteriaRemaining.value?.find((c) => c.groupId === groupId)?.count || 0;
};

const openCriteriaDetail = (group: ICriteriaGroupDTO) => {
  selectedCriteriaGroup.value = group;
  openSubView.value = true;
};
</script>

<!-- TODO
1. Secure this endpoint
-->
